const messageInvalid = 'Valor do campo não é válido.';
const messageRequired = 'Este campo é obrigatório';
const emailPattern =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;



export const required = v => {
  if (v === null || v === undefined || String(v).trim() === '' || v.length === 0)
    return messageRequired;

  return true;
}

export const email = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '') return true;

  return emailPattern.test(v) || 'E-mail Inválido!';
};

export const cpf_cnpj = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '') return true;

  if (!isNaN(v)) {
    v = v.toString();
  }

  v = v.replace(/\-/g, '').replace(/\./g, '').replace(/\//g, '');

  if (v.length === 11) {
    if (!/^[0-9]+$/.test(v)) return messageInvalid;
    return cpf(v);
  } else if (v.length === 14) {
    if (!/^[a-zA-Z0-9]+$/.test(v)) return messageInvalid;
    return cnpj(v);
  } else {
    return messageInvalid;
  }
};

export const cpf = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '') return true;

  if (!isNaN(v)) {
    v = v.toString().padStart(11, '0');
  }

  v = v.replace(/\-/g, '').replace(/\./g, '');

  if (!/^[0-9]+$/.test(v)) return messageInvalid;

  if (
    v.length != 11 ||
    v == '191' ||
    v == '00000000000' ||
    v == '11111111111' ||
    v == '22222222222' ||
    v == '33333333333' ||
    v == '44444444444' ||
    v == '55555555555' ||
    v == '66666666666' ||
    v == '77777777777' ||
    v == '88888888888' ||
    v == '99999999999'
  ) {
    return messageInvalid;
  }

  let total, index, leftover, verifyingDigit, counter;

  if (v.length >= 11) {
    index = 2;
    total = 0;
    leftover = 0;
    verifyingDigit = 0;

    for (counter = -9; counter <= -1; counter++) {
      total = total + Math.abs(v.substr(Math.abs(counter) - 1, 1) * index);
      index = index + 1;
    }

    leftover = total % 11;

    leftover === 0 || leftover === 1 ? (verifyingDigit = 0) : (verifyingDigit = 11 - leftover);

    if ('' + v.substr(9, 1) != '' + verifyingDigit) {
      return messageInvalid;
    }

    index = 2;
    total = 0;
    leftover = 0;
    verifyingDigit = 0;

    for (counter = -10; counter <= -1; counter++) {
      total = total + Math.abs(v.substr(Math.abs(counter) - 1, 1) * index);
      index = index + 1;
    }

    leftover = total % 11;

    leftover === 0 || leftover === 1 ? (verifyingDigit = 0) : (verifyingDigit = 11 - leftover);

    if ('' + v.substr(10, 1) !== '' + verifyingDigit) {
      return messageInvalid;
    }
  }

  return true;
};

export const cnpj = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '') return true;

  if (!isNaN(v)) {
    v = v.toString().padStart(14, '0');
  }

  v = v.replace(/\-/g, '').replace(/\./g, '').replace(/\//g, '');

  if (!/^[a-zA-Z0-9]+$/.test(v)) return messageInvalid;

  if (
    v.length != 14 ||
    v == '00000000000000' ||
    v == '11111111111111' ||
    v == '22222222222222' ||
    v == '33333333333333' ||
    v == '44444444444444' ||
    v == '55555555555555' ||
    v == '66666666666666' ||
    v == '77777777777777' ||
    v == '88888888888888' ||
    v == '99999999999999'
  ) {
    return messageInvalid;
  }


  // Ajusta o valor para garantir que tenha exatamente 14 caracteres
  v = v.padStart(14, '0').slice(-14);

  const calcularDigito = (valor, pesoInicial) => {
    let soma = 0;
    let peso = pesoInicial;

    for (let i = valor.length - 1; i >= 0; i--) {
      const char = valor[i];
      const valorNumerico = char.match(/[0-9]/) ? parseInt(char) : char.charCodeAt(0) - 48; // A=17, B=18, ..., Z=35
      soma += valorNumerico * peso;
      peso = (peso === 9) ? 2 : peso + 1;
    }

    const resto = soma % 11;
    return (resto < 2) ? 0 : 11 - resto;
  };

  // Calcula o primeiro dígito verificador
  const digito1 = calcularDigito(v.slice(0, 12), 2);
  if (parseInt(v[12], 36) !== digito1) {
    return messageInvalid;
  }

  // Calcula o segundo dígito verificador
  const digito2 = calcularDigito(v.slice(0, 13), 2);
  if (parseInt(v[13], 36) !== digito2) {
    return messageInvalid;
  }

  return true;
};

export const validateNumberInt = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '') return true;


  const regex = new RegExp('^-?[0-9]+$');

  if (!regex.test(v)) return messageInvalid;

  v = parseInt(v);

  return true;
};

export const validateNumberInt16 = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = parseInt(v);

  if (v < -32768) return 'O valor do campo é muito pequeno. Valor mínimo: -32768';

  if (v > 32767) return 'O valor do campo é muito grande. Valor máximo: 32767';

  return true;
};

export const validateNumberTinyInt = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = parseInt(v);

  if (v < 0) return 'O valor do campo deve ser positivo';

  if (v > 255) return 'O valor do campo é muito grande';

  return true;
};

export const validatePercentage = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  c1 === '.' ? (c2 = ',') : (c2 = '.');

  if (v.indexOf(c1) > 0) return messageInvalid;

  v = Math.abs(v.replace(c2, c1));

  if (isNaN(v)) return messageInvalid;

  if (v > 100) return 'O valor do campo não poderá ser maior que 100%.';

  return true;
};

export const validatePercentageWithoutNegative = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  c1 === '.' ? (c2 = ',') : (c2 = '.');

  if (v.indexOf(c1) > 0) return messageInvalid;

  if (parseFloat(v.replace(c2, c1)) < 0) return 'O valor do campo não poderá ser inferior que 0%.';

  v = Math.abs(v.replace(c2, c1));

  if (isNaN(v)) return messageInvalid;

  if (v > 100) return 'O valor do campo não poderá ser maior que 100%.';

  return true;
};

export const validateIntegerPositive = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  if (c1 == '.') {
    c2 = ',';
    v = v.toString().replace(/[.]/g, '');
  } else {
    c2 = '.';
    v = v.toString().replace(/[,]/g, '');
  }

  if (v.indexOf(c1) > 0) return messageInvalid;

  v = v.replace(c2, c1);

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  if (v <= 0) return 'Digite apenas valores positivos.';

  if (v.length === 0) return true;

  const regex = new RegExp('^-?[0-9]+$');

  if (!regex.test(v)) return messageInvalid;

  return true;
};

export const validateIntegerNegative = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  c1 === '.' ? (c2 = ',') : (c2 = '.');

  if (v.indexOf(c1) > 0) return messageInvalid;

  if (parseFloat(v.replace(c2, c1)) < 0) return 'O valor do campo não poderá ser inferior que 0%.';

  v = Math.abs(v.replace(c2, c1));

  if (isNaN(v)) return messageInvalid;

  return true;
};

export const validateNegativeValue = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = parseInt(v);

  if (v > 1) return 'Digite apenas valores negativos.';

  return true;
};

export const validatePositiveValue = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  let c1 = String(3 / 2).charAt(1);
  let c2 = '';

  if (c1 === '.') {
    c2 = ',';
    v = v.toString().replace(/[.]/g, '');
  } else {
    c2 = '.';
    v = v.toString().replace(/[,]/g, '');
  }

  // Verifica se contém virgula como separador
  if (v[v.indexOf(c2)] === ',') {
    v = v.replace(c2, c1);

    // Verifica se o valor convertido para decimalInt é negativo
    if (v <= 0) return 'Digite apenas valores positivos.'
    return true;
  }

  if (v.indexOf(c1) > 0) return messageInvalid;

  v = v.replace(c2, c1);

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  if (v <= 0) return 'Digite apenas valores positivos.';

  return true;
};

export const validatePercentageLessThan100 = v => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  if (validateNumberInt(v) !== true) return validateNumberInt(v);

  v = Math.abs(v.replace(',', '.'));

  if (v >= 100) return 'O valor do campo não poderá ser maior ou igual a 100%.';

  return true;
};

export const messageErrorContainSpecialCharacter = "Texto contém caractere inválido.";
export const validateTextWithoutSpecialCharacters = (v, allowedChars = []) => {
  //se o valor for vazio retorna verdadeiro pois é responsabilidade do validador required determinar se é obrigatório ou não
  if (v === null || v === undefined || v === '' || v.length === 0) return true;

  let specialChars = [
    "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "-", "_", "+", "=", "{", "}", "[", "]", "|", "\\", ":", ";", ".", ",", "<", ">", "?", "/", "~", "`", "´", '"', "'", "º", "ª", "³", "²", "£", "¢", "¬", "§", "°", "¨", "¹", "²", "³", "£", "¢", "¬", "§", "ª", "º", "¿", "¡", "µ", "¶", "·"
  ]

  specialChars = specialChars.filter(char => !allowedChars.includes(char));
  const specialCharsSet = new Set(specialChars);

  // o regex foi substituido por um Set com has() por conta dos caracteres especiais do próprio Regex, como o "-"
  for (let i = 0; i < v.length; i++) {
    if (specialCharsSet.has(v[i])) {
      return messageErrorContainSpecialCharacter;
    }
  }

  return true;
};
